// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ba-0";
export var headerCellHover = "_ba-1";
export var readCellContainer = "_ba-2";
export var readCellSlot = "_ba-3";
export var rowHoverCheckbox = "_ba-4";
export var rowUnreadIndicator = "_ba-5";
export var searchHighlight = "_ba-8";
export var supportTicketRow = "_ba-6";
export var unreadIndicator = "_ba-7";